import React from 'react'

/**
 * Root error boundary.
 *
 * Prevents a render crash from blanking the entire SPA (there was no root
 * boundary before). Renders a minimal fallback carrying `data-testid="app-crash"`
 * — both a UX improvement (a reload affordance instead of a white screen) and a
 * deterministic crash signal for the AI UI test automation (ADR 0008).
 */
class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error(
      '[RootErrorBoundary] Uncaught error:',
      error,
      info?.componentStack
    )
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="app-crash"
          className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-4 bg-dark-blue text-white p-6 text-center"
        >
          <p className="text-lg font-light">
            Si è verificato un errore imprevisto nell'applicazione.
          </p>
          <button
            className="bg-blue hover:bg-blue-hover transition rounded-xl px-4 py-2"
            onClick={this.handleReload}
          >
            Ricarica
          </button>
        </div>
      )
    }
    return this.props.children
  }
}

export default RootErrorBoundary
